import { TemplateId } from "../../globalTypes";
import * as Global from "../../utils/global";
import { RowKey } from "../table/types";

// Basic table row stuff

export const GetTableRowByTemplateId = (rowKeyValue: RowKey): string =>
  `api/Database/Row/ByTemplateId/${rowKeyValue}`;

export const UpdateTableRowByTemplateId = (
  rowKeyValue: RowKey,
  templateId: TemplateId
): string =>
  `api/Database/Row/ByTemplateId/${rowKeyValue}?templateId=${templateId}`;

export const getValuesToPrefill = (): string =>
  `/api/Database/Row/Prefill/ByTemplateId`;

export const DeleteTableRowByTemplateId = (
  rowKeyValue: RowKey,
  templateId: TemplateId
): string =>
  `api/Database/Row/ByTemplateId/${rowKeyValue}?templateId=${templateId}`;

export const AddNewTableRowByTemplateId = (templateId: TemplateId): string =>
  `api/Database/Row/ByTemplateId?templateId=${templateId}`;

export const GetEmptyTableRowByTemplateId = (templateId: TemplateId): string =>
  `api/Database/EmptyRow/ByTemplateId?templateId=${templateId}`;

export const GetColumnsWithSelectItemJoins = (
  dbContext: string,
  tableName: string
): string => {
  const database = Global.GetControllerNameByDbContext(dbContext);
  return `api/${database}/Table?tableName=${tableName}`;
};
